import { MeterReadReducer } from '../interfaces';
import { createReducer } from '@reduxjs/toolkit';

const initialState: MeterReadReducer = {
  getMeterRead: {
    status: {
      loading: false,
      error: false,
      done: false,
    },
    data: null,
  },
  submitMeterRead: {
    status: {
      loading: false,
      error: false,
      done: false,
    },
    data: null,
  },
};

const meterReadReducer = createReducer(initialState, {
  GET_METER_READ_PENDING: (state) => {
    state.getMeterRead.status = {
      loading: true,
      error: false,
      done: false,
    };
  },

  GET_METER_READ_FULFILLED: (state, action) => {
    state.getMeterRead.status = {
      loading: false,
      error: false,
      done: true,
    };
    state.getMeterRead.data = action.payload.data;
  },

  GET_METER_READ_REJECTED: (state) => {
    state.getMeterRead.status = {
      loading: false,
      error: true,
      done: false,
    };
    state.getMeterRead.data = null;
  },
  SUBMIT_METER_READ_PENDING: (state) => {
    state.submitMeterRead.status = {
      loading: true,
      error: false,
      done: false,
    };
  },

  SUBMIT_METER_READ_FULFILLED: (state, action) => {
    state.submitMeterRead.status = {
      loading: false,
      error: false,
      done: true,
    };
    state.submitMeterRead.data = action.payload.data;
  },

  SUBMIT_METER_READ_REJECTED: (state, action) => {
    state.submitMeterRead.status = {
      loading: false,
      error: action.payload.data.message,
      done: false,
    };
    state.submitMeterRead.data = null;
  },
});

export default meterReadReducer;
